export default __webpack_public_path__ + "static/media/Artboard 15.fce08caa.png";